import { ProgressBar } from '~/primitives/progressbar';
import { Pack, PackLevel } from '~/util/types/packs';

const PackProgress: React.FC<
    { pack: Pack; selected: boolean } & React.ComponentProps<'div'>
> = ({ pack, selected, ...props }) => {
    const nbCompleted = pack.levels.reduce((acc: number, level: PackLevel) => {
        if (level.completed_by_user) {
            return acc + 1;
        }
        return acc;
    }, 0);

    return (
        <div {...props}>
            <ProgressBar
                value={nbCompleted}
                max={pack.levels.length}
                isLabelVisible={false}
                animateOnRender
                className="bg-secondary-light"
                indicatorClassName={
                    selected ? 'bg-primary-foreground' : 'bg-primary'
                }
                height="5px"
            />
        </div>
    );
};

export default PackProgress;
